import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";

type Props = {
  /**
   * A string representing the breadcrumb path.
   */
  breadcrumbPath: string;
};

export const BreadcrumbsUI = ({ breadcrumbPath }: Props) => (
  <div data-testid="breadcrumbs" className="esi-wrapper">
    <ESIInclude src={breadcrumbPath} id={"breadcrumbs"} />
  </div>
);
